import React, { useEffect, useState } from "react";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import Icon from "@mui/material/Icon";
import MDTypography from "components/MDTypography";

import Swal from "sweetalert2";

import Loader from "Loader";
import SearchAccSessionReq from "../../../Classes/Models/Requests/AccountingSessions/CreateAccountingSessionReq";
import { useNavigate } from "react-router-dom";

import SessionsApi from "../../../Classes/API/Administration/SessionsApi";
import SearchStringOrIntReq3 from "../../../Classes/Models/Requests/SearchStringOrIntReq";
import DataTable from "examples/Tables/DataTable";
import MDButton from "components/MDButton";

const SingleSessionsTable = ({ CurrentUser }) => {
  let navigate = useNavigate();

  const TableColumns = [
    { Header: "Acc. Session ID", accessor: "Id", align: "left" },

    { Header: "Patient", accessor: "Patient", align: "left" },

    { Header: "Session", accessor: "Session", align: "left" },
    // { Header: "Therapists", accessor: "Therapists", align: "left" },
    { Header: "Paid For", accessor: "PaidFor", align: "left" },

    { Header: "Original Price", accessor: "OriginalPrice", align: "left" },
    { Header: "Discount", accessor: "Discount", align: "left" },
    { Header: "Final Price", accessor: "FinalPrice", align: "left" },

    { Header: "Details", accessor: "Edit", align: "center" },
  ];

  const [TableDataRows, setTableDataRows] = useState([]);

  const [ResponseData, setResponseData] = useState({});

  const [IsLoaded, setIsLoaded] = useState(false);

  const GetOptions = (session) => {
    navigate("/PatientAccountingSessions/Details", {
      state: {
        SearchSession: session,
      },
    });
  };

  const MakeTableRow = (session, index) => {
    return {
      Id: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {session.id}
        </MDTypography>
      ),

      Session: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {session.getSession.name}
        </MDTypography>
      ),

      Patient: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {session.getPatient.getUser.name}
        </MDTypography>
      ),
      PaidFor: (
        <input
          id={"S.isPaidFor" + session.id}
          type="checkbox"
          disabled
          defaultChecked={session.isPaidFor}
        />
      ),
      OriginalPrice: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {session.originalPrice}
        </MDTypography>
      ),

      Discount: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {Number(session.discount).toFixed(1)}%
        </MDTypography>
      ),

      FinalPrice: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {session.finalPrice}
        </MDTypography>
      ),

      Edit: (
        <MDTypography
          onClick={() => {
            GetOptions(session);
          }}
          component="a"
          variant="button"
          color="text"
          fontWeight="medium"
        >
          <Icon>more_vert</Icon>
        </MDTypography>
      ),
    };
  };

  const GetTableData = async () => {
    let req = new SearchAccSessionReq();
    if (!CurrentUser || !CurrentUser.getUser || !CurrentUser.getUser.getPatient) {
      return;
    }

    req.patientId = CurrentUser.getPatient.id;
    req.pagingParams.pageSize = 5;

    var res = await SessionsApi.SearchAccountingSessions(req);

    if (res.status == "Success") {
      let tempResponseData = [...res.data.list];

      // var resList = res.data.list;

      setResponseData(tempResponseData);
      // setTableDataRows(rows);
      setIsLoaded(true);
    }
  };
  const RefreshTable = (resList) => {
    var rows = [];
    resList.forEach((session, index) => {
      rows.push(MakeTableRow(session, index));
    });
    setTableDataRows(rows);
  };

  useEffect(async () => {
    //Get data

    if (!IsLoaded && Object.keys(CurrentUser).length > 0) {
      await GetTableData();
    }
  }, [IsLoaded, CurrentUser]);

  useEffect(() => {
    //Get data

    if (ResponseData.length > 0) {
      RefreshTable(ResponseData);
    }
  }, [ResponseData]);

  if (!IsLoaded) {
    const loaderType = "balls";
    const loaderColor = "black";

    return <Loader type={loaderType} color={loaderColor} />;
  }
  return (
    <Card>
      <MDBox
        mx={2}
        mt={3}
        py={3}
        px={2}
        variant="gradient"
        bgColor="info"
        borderRadius="lg"
        coloredShadow="info"
      >
        <MDTypography variant="h6" color="white">
          Accounting Sessions 
        </MDTypography>
        <MDTypography variant="h6" color="white">
          {/* Patient: ({ResponseData.length > 0 ? ResponseData[0].getPatient.getUser.name : 0}) */}
          Patient: ({Object.keys(CurrentUser).length > 0 ? CurrentUser.name : "No User"})
        </MDTypography>
      </MDBox>
      <MDBox pt={3}>
        <DataTable
          table={{ columns: TableColumns, rows: TableDataRows }}
          isSorted={false}
          entriesPerPage={false}
          showTotalEntries={false}
          noEndBorder
        />
      </MDBox>
    </Card>
  );
};

export default SingleSessionsTable;
